import { isBrowser } from './isBrowser';

export const getScrollbarWidth = () => {
  if (!isBrowser) {
    return 8; // TODO: временно. Мы не знаем какая на самом деле ширина у браузерного скроллбара.
  }

  const div = document.createElement('div');

  div.style.overflowY = 'scroll';
  div.style.width = '50px';
  div.style.height = '50px';
  div.style.visibility = 'hidden';
  div.style.flexShrink = '0';

  document.body.appendChild(div);
  const scrollWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);

  return scrollWidth;
};
